import React, { useEffect } from 'react';
import ChatWidget from '../components/ChatWidget';
import WidgetThemeProvider from '../components/ChatWidget/WidgetThemeProvider';

/**
 * Embed sayfasi — baska sitelere iframe ile gomulen ciplak widget.
 * public/embed.js bu sayfayi bir iframe icinde yukler.
 * Arka plan seffaf: iframe kapaliyken sadece baloncuk gorunur,
 * sayfanin geri kalani tiklanabilir kalir.
 */
const EmbedPage = () => {
  useEffect(() => {
    const prevHtml = document.documentElement.style.background;
    const prevBody = document.body.style.background;
    document.documentElement.style.background = 'transparent';
    document.body.style.background = 'transparent';
    // Embed moduna ozel CSS icin isaret ( or. mobilde tam ekran)
    document.body.classList.add('lidya-embed');
    return () => {
      document.documentElement.style.background = prevHtml;
      document.body.style.background = prevBody;
      document.body.classList.remove('lidya-embed');
    };
  }, []);

  return (
    <WidgetThemeProvider>
      <ChatWidget />
    </WidgetThemeProvider>
  );
};

export default EmbedPage;
